import {IBeginPaymentInvoiceRequest, IClientPaymentCallbacks} from "./begin-payment-base.request";
import {IVoucherPaymentRequest} from "./voucher-payment.request";
import {BookingFlowTypeEnum} from "../../booking/booking-strategies/booking-flow-type.enum";
import {NullableString} from "../../../types/nullable-types";
import {IPsoWorkerAgreementRequest} from "./pso-worker-agreement.request";
import {IPsoFamilyAgreementRequest} from "./pso-family-agreement.request";


export enum MobileWalletProviderEnum {
    GooglePay = 1,
    ApplePay = 2
}

export interface IPaymentCardDetails {
    cardNumber: string;
    cardHolder: string;
    expirationMonth: string;
    expirationYear: string;
    cvv: string;
}

export interface IPaymentBrowserDetails {
    readonly language: string;
    readonly colorDepth: number;
    readonly screenWidth: number;
    readonly screenHeight: number;
    readonly timeZoneOffset: number;
    readonly userAgent: string;
    readonly javaEnabled: boolean;

}


export interface IBeginBookingPaymentRequest extends IBeginPaymentInvoiceRequest {
    dotRezToken: string;
    bookingTimestamp: number;
    attempt: number;
    paymentMethodCode: string;
    pspCode: string;
    callbacks: IClientPaymentCallbacks;
    culture: string;
    vouchers: IVoucherPaymentRequest[]
    psoWorkersAgreements: IPsoWorkerAgreementRequest[];
    psoFamilyAgreements: IPsoFamilyAgreementRequest[];
    organizationCredit: number;
    bookingFlow: BookingFlowTypeEnum,
    agentName: NullableString;
    mobileWalletProvider?: MobileWalletProviderEnum;
    mobileWalletToken?: NullableString;
    cardDetails?: IPaymentCardDetails;
    browserDetails: IPaymentBrowserDetails;
    useIframeForRedirect: boolean;
}